import { stripLocaleFromPath } from "@/i18n/locale-utils";

export type BannerVariant =
  | "default"
  | "catalog"
  | "coaching"
  | "fractional"
  | "microservices"
  | "legal"
  | "editorial";

export interface BannerEntry {
  /** i18n key under `banner.<key>` */
  key: string;
  variant: BannerVariant;
  /** matcher: exact path or regex */
  match: string | RegExp;
}

export const BANNER_CONFIG: BannerEntry[] = [
  { match: "/catalog", key: "catalog", variant: "catalog" },
  { match: "/pricing", key: "pricing", variant: "default" },
  { match: "/about", key: "about", variant: "editorial" },
  { match: "/careers", key: "careers", variant: "default" },
  { match: /^\/careers\/[^/]+$/, key: "careersDetail", variant: "default" },
  { match: "/case-studies", key: "caseStudies", variant: "editorial" },
  { match: "/contact", key: "contact", variant: "default" },
  { match: "/community", key: "community", variant: "default" },
  { match: "/support", key: "support", variant: "default" },
  { match: "/faq", key: "faq", variant: "default" },
  { match: "/legal/terms", key: "legalTerms", variant: "legal" },
  { match: "/legal/privacy", key: "legalPrivacy", variant: "legal" },
  { match: "/legal/refund-policy", key: "legalRefundPolicy", variant: "legal" },
  { match: "/fractional", key: "fractional", variant: "fractional" },
  { match: /^\/fractional\/[^/]+$/, key: "fractionalDetail", variant: "fractional" },
  { match: "/mentoring", key: "mentoring", variant: "coaching" },
  { match: "/services", key: "services", variant: "default" },
  { match: "/services/coaching", key: "coaching", variant: "coaching" },
  { match: /^\/services\/coaching\/[^/]+$/, key: "coachingDetail", variant: "coaching" },
  { match: "/services/microservices", key: "microservices", variant: "microservices" },
  { match: /^\/services\/microservices\/[^/]+$/, key: "microservicesDetail", variant: "microservices" },
  { match: "/services/retainers", key: "retainers", variant: "coaching" },
  { match: "/services/investor-readiness", key: "investorReadiness", variant: "fractional" },
  { match: "/downloads", key: "downloads", variant: "editorial" },
  { match: "/enterprise", key: "enterprise", variant: "fractional" },
];

export function resolveBanner(pathname: string): BannerEntry | null {
  const { rest } = stripLocaleFromPath(pathname);
  // normalize: remove trailing slash, default to "/"
  const path = rest.replace(/\/+$/, "") || "/";
  if (path === "/" || path === "") return null;

  // prefer exact string matches first
  for (const e of BANNER_CONFIG) {
    if (typeof e.match === "string" && e.match === path) return e;
  }
  for (const e of BANNER_CONFIG) {
    if (e.match instanceof RegExp && e.match.test(path)) return e;
  }
  return null;
}
